import { IRectangle, List } from '@fluentui/react';
import { StyleUtils } from '../../common/views/StyleUtils';
import { PhotoShapeManager } from '../../photoCollages/views/PhotoShapeManager';
import { NewFeedModel } from '../models/NewFeedModel';
import NewFeedRowView from './NewFeedRowView';

type NewFeedGridProps = {
    feeds: NewFeedModel[];
    onEdit: (feed: NewFeedModel) => void;
    onDetail: (feed: NewFeedModel) => void;
    onActivate: (feed: NewFeedModel) => void;
}

export default function NewFeedGridView({ feeds, onEdit, onDetail, onActivate }: NewFeedGridProps) {
    var columnCount: number = 0;
    const photoManager = new PhotoShapeManager(250);;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            const width = surfaceRect?.width ?? 0;

            if (width < 500) columnCount = 1;
            else if (width < 1000) columnCount = 2;
            else columnCount = 3;
        }

        return feeds.length;
    }

    const onRenderCell = (feed?: NewFeedModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const height = columnCount === 1 ? "auto" : 650;

        if (feed == null) return <>empty</>;

        return <div
            key={feed.id + "-wrapper"}
            className="list-grid-tile"
            data-is-focusable={true}
            style={StyleUtils.getProductItemStyles(width, height)}
        >
            <NewFeedRowView
                key={feed.id}
                feed={feed}
                onEdit={onEdit}
                onDetail={onDetail}
                onActivate={onActivate}
                photoManager={photoManager}
            />
        </div>;
    }

    return <div style={{ marginLeft: -20, marginRight: -20 }}>
        <List
            items={feeds}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}